import React from 'react';

var WebGameColumnInner = function (_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? 'left' : _b;
    if (position === 'center') {
        return React.createElement("div", { className: "inner-".concat(position, "-column") }, children);
    }
    return (React.createElement("div", { className: "inner-".concat(position, "-column") },
        React.createElement("div", { className: 'inner-wrapper' }, children)));
};

export { WebGameColumnInner };
